import { gl } from '../context.js';

function Draw(shader) {
  // vertices
  gl.enableVertexAttribArray(shader.attributes.vPosition);
  gl.bindBuffer(gl.ARRAY_BUFFER, this.vertexBuffer);
  gl.vertexAttribPointer(shader.attributes.vPosition, 2, gl.FLOAT, false, 0, 0);
  if (gl.ext.instances) {
    gl.ext.instances.vertexAttribDivisorANGLE(shader.attributes.vPosition, 0);
  } else {
    gl.vertexAttribDivisor(shader.attributes.vPosition, 0);
  }

  // instances
  gl.enableVertexAttribArray(shader.attributes.vInstance);
  gl.bindBuffer(gl.ARRAY_BUFFER, this.instanceBuffer);
  gl.vertexAttribPointer(shader.attributes.vInstance, 3, gl.FLOAT, false, 0, 0);
  if (gl.ext.instances) {
    gl.ext.instances.vertexAttribDivisorANGLE(shader.attributes.vInstance, 1);
  } else {
    gl.vertexAttribDivisor(shader.attributes.vInstance, 1);
  }

  // uvs
  gl.enableVertexAttribArray(shader.attributes.vTexCoords);
  gl.bindBuffer(gl.ARRAY_BUFFER, this.texCoordsBuffer);
  gl.vertexAttribPointer(shader.attributes.vTexCoords, 4, gl.FLOAT, false, 0, 0);
  if (gl.ext.instances) {
    gl.ext.instances.vertexAttribDivisorANGLE(shader.attributes.vTexCoords, 1);
  } else {
    gl.vertexAttribDivisor(shader.attributes.vTexCoords, 1);
  }

  // draw array instnaces
  if (gl.ext.instances) {
    gl.ext.instances.drawArraysInstancedANGLE(gl.TRIANGLE_STRIP, 0, 4, this.instancesCount);
  } else {
    gl.drawArraysInstanced(gl.TRIANGLE_STRIP, 0, 4, this.instancesCount);
  }
}

function Instances() {
  var uvs = [
    0.009765625, 0.0126953125, 0.7236328125, 0.037109375, 0.73828125, 0.0126953125, 0.20703125, 0.037109375, 0.01171875, 0.0595703125, 0.7392578125, 0.037109375, 0.7607421875, 0.0595703125, 0.2060546875, 0.037109375, 0.009765625, 0.1064453125, 0.60546875, 0.037109375, 0.6220703125, 0.1064453125, 0.3681640625, 0.037109375, 0.009765625, 0.1533203125, 0.55859375, 0.037109375, 0.57421875, 0.1533203125, 0.416015625, 0.037109375, 0.009765625, 0.2001953125, 0.5361328125, 0.037109375, 0.5498046875, 0.2001953125, 0.4423828125, 0.037109375, 0.009765625, 0.2470703125, 0.5361328125, 0.037109375, 0.548828125, 0.2470703125, 0.44140625, 0.037109375, 0.009765625, 0.2939453125, 0.53515625, 0.037109375, 0.548828125, 0.2939453125, 0.44140625, 0.037109375, 0.01171875, 0.3408203125, 0.486328125, 0.037109375, 0.501953125, 0.3408203125, 0.48828125, 0.037109375, 0.01171875, 0.3876953125, 0.4873046875, 0.037109375, 0.50390625, 0.3876953125, 0.4873046875, 0.037109375, 0.009765625, 0.4345703125, 0.3486328125, 0.037109375, 0.36328125, 0.4345703125, 0.3232421875, 0.037109375, 0.69140625, 0.4345703125, 0.2998046875, 0.037109375, 0.01171875, 0.4814453125, 0.3232421875, 0.037109375, 0.337890625, 0.4814453125, 0.3251953125, 0.037109375, 0.666015625, 0.4814453125, 0.32421875, 0.037109375, 0.009765625, 0.5283203125, 0.3251953125, 0.037109375, 0.33984375, 0.5283203125, 0.322265625, 0.037109375, 0.66796875, 0.5283203125, 0.3232421875, 0.037109375, 0.01171875, 0.5751953125, 0.4873046875, 0.037109375, 0.50390625, 0.5751953125, 0.462890625, 0.037109375, 0.009765625, 0.6220703125, 0.46484375, 0.037109375, 0.48046875, 0.6220703125, 0.46484375, 0.037109375, 0.009765625, 0.6689453125, 0.4189453125, 0.037109375, 0.43359375, 0.6689453125, 0.416015625, 0.037109375, 0.01171875, 0.7158203125, 0.416015625, 0.037109375, 0.43359375, 0.7158203125, 0.392578125, 0.037109375, 0.83203125, 0.7158203125, 0.158203125, 0.037109375, 0.01171875, 0.7626953125, 0.3935546875, 0.037109375, 0.4091796875, 0.7626953125, 0.39453125, 0.037109375, 0.80859375, 0.7626953125, 0.16015625, 0.037109375, 0.01171875, 0.8095703125, 0.392578125, 0.037109375, 0.408203125, 0.8095703125, 0.3955078125, 0.037109375, 0.009765625, 0.8564453125, 0.3720703125, 0.037109375, 0.384765625, 0.8564453125, 0.3486328125, 0.037109375, 0.736328125, 0.8564453125, 0.2548828125, 0.037109375, 0.009765625, 0.9033203125, 0.30078125, 0.037109375, 0.314453125, 0.9033203125, 0.279296875, 0.037109375, 0.59765625, 0.9033203125, 0.2763671875, 0.037109375, 0.01171875, 0.9501953125, 0.2763671875, 0.037109375, 0.291015625, 0.9501953125, 0.27734375, 0.037109375, 0.57421875, 0.9501953125, 0.228515625, 0.037109375, 0.80859375, 0.9501953125, 0.134765625, 0.037109375
  ];
  var uvsCount = parseInt(uvs.length / 4);

  var instances = {
    instances: [],
    uvs: [],
  };
  var size = 45;
  var count = 1000;
  for (var i = 0; i < count; i++) {
    var angle = Math.random() * Math.PI * 2;
    var x = Math.random() * 2 - 1;
    var y = Math.random() * 2 - 1;
    var z = Math.random() * 2 - 1;
    var ratio = (Math.random() * 0.5 + 0.5) * size;
    var div = ratio / Math.sqrt(x * x + y * y + z * z);
    instances.instances.push(x * div, y * div, z * div);

    // uvs
    var id = Math.floor(Math.random() * uvsCount) * 4;
    instances.uvs.push(
      uvs[id + 0],
      1 - uvs[id + 1] - uvs[id + 3],
      uvs[id + 2],
      uvs[id + 3],
    );
  }

  return instances;
}

function Mesh(json) {
  var instances = Instances();

  // vertices buffer
  var vertexBuffer = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(json.vertices), gl.STATIC_DRAW);

  // instances buffer
  var instanceBuffer = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, instanceBuffer);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(instances.instances), gl.STATIC_DRAW);

  // UVS buffer
  var texCoordsBuffer = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, texCoordsBuffer);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(instances.uvs), gl.STATIC_DRAW);

  return {
    vertexBuffer,
    instanceBuffer,
    texCoordsBuffer,
    instancesCount: instances.instances.length / 3,
    Draw
  };
}

export { Mesh }
